//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "@/components/Header";
import Logo from "@/components/Logo";
import LeftPattern from "@/components/LeftPattern";
import Container from "@/components/Container";
import BackgroundText from "@/components/BackgroundText";
import Copy from "@/components/Copy";
import Car from "@/components/Car";
import PhotoText from "@/components/PhotoText";
import PhotoTextSecond from "@/components/PhotoTextSecond";
import Gradient from "@/components/Gradient";
import Slider from "@/components/Slider";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default {
  data() {
    return {
      selectedService: "",
    };
  },
  name: "app",
  components: {
    Header,
    Logo,
    LeftPattern,
    Container,
    BackgroundText,
    Copy,
    Car,
    PhotoText,
    PhotoTextSecond,
    Gradient,
    Slider,
    ContactForm,
    Footer,
  },
  methods: {
    goto(url) {
      window.location.href = url;
    },
  },
};
